import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTimeOfDayBucket } from '@/hooks/useTimeOfDay';

/**
 * Static demo pages still useful for QA + design review (states.tsx) and
 * the catch-all 404. All other Phase-C placeholders moved out to real
 * implementations in their own route files.
 */

export function StatesRoute() {
  const { t } = useTranslation();
  const bucket = getTimeOfDayBucket();
  return (
    <div className="mx-auto max-w-[640px] px-4 pb-16 pt-6">
      <h1 className="h1 m-0 mb-6">Edge states</h1>
      <p className="muted mb-4">
        These are the empty / error / loading copy strings the rest of the app uses. Useful for
        translation QA and copy-tuning.
      </p>
      <dl className="grid grid-cols-[160px_1fr] gap-x-4 gap-y-2 text-sm">
        <dt className="font-semibold text-ink-muted">Time-of-day empty</dt>
        <dd>
          {bucket} → &ldquo;{t(`empty.${bucket}`)}&rdquo;
        </dd>
        <dt className="font-semibold text-ink-muted">Offline</dt>
        <dd>{t('errors.offline')}</dd>
        <dt className="font-semibold text-ink-muted">Geofence reject</dt>
        <dd>{t('vote.geofence')}</dd>
        <dt className="font-semibold text-ink-muted">Rate-limited</dt>
        <dd>{t('vote.rate_limited')}</dd>
        <dt className="font-semibold text-ink-muted">Geo denied</dt>
        <dd>{t('vote.geo_denied')}</dd>
        <dt className="font-semibold text-ink-muted">Vote success</dt>
        <dd>{t('vote.success_long')}</dd>
      </dl>
    </div>
  );
}

export function NotFoundRoute() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-[480px] px-4 py-12 text-center">
      <div className="mb-3 text-5xl" aria-hidden="true">
        🥢
      </div>
      <h1 className="m-0 mb-2 text-2xl font-bold">{t('errors.page_not_found')}</h1>
      <p className="m-0 mb-4 text-sm text-ink-soft">
        We couldn&apos;t find that page. Head back to the map and try again.
      </p>
      <Link
        to="/"
        className="inline-flex min-h-[44px] items-center justify-center rounded-md bg-soi-600 px-4 py-2 text-sm font-semibold text-white"
      >
        {t('errors.back_to_map')}
      </Link>
    </div>
  );
}
